export const getStringWithOutSpaces = (string) => string.replace(/ /g, '');
